/** Matches the Completed tab on the State Report workspace. */
export const STATE_REPORT_COMPLETED_TAB = 2;

export const OUTSTANDING_STATUS_ACTIONS = [
  "Not Started",
  "Waiting on Client",
  "No Report Required",
];

export const COMPLETED_STATUS_ACTIONS = [
  "Not Started",
  "Waiting on Client",
  "No Report Required",
  "Revised",
];

const REVISED_ONLY = ["Revised"];

/**
 * Client-done is stored as a boolean or the string "true" from the reporting SQL.
 */
export function isStateReportDoneByClient(isDoneByClient: unknown): boolean {
  return isDoneByClient === true || String(isDoneByClient) === "true";
}

/**
 * Completed rows the client already marked done stay Filed.
 * The Status menu on those rows offers only Revised, including a mixed selection.
 * Outstanding keeps the normal work actions so the revised copy can be filed.
 */
export function stateReportStatusMenuActions(
  selectedTab: number,
  selectedRows: ReadonlyArray<{ isDoneByClient?: unknown }> | null | undefined
): string[] {
  if (selectedTab !== STATE_REPORT_COMPLETED_TAB) {
    return OUTSTANDING_STATUS_ACTIONS;
  }

  const anyClientDone = (selectedRows ?? []).some((row) =>
    isStateReportDoneByClient(row.isDoneByClient)
  );
  return anyClientDone ? REVISED_ONLY : COMPLETED_STATUS_ACTIONS;
}
